import { Extension } from "@tiptap/core";
import { Suggestion } from "@tiptap/suggestion";
import { createCollaborateSlashSuggestion } from "./createCollaborateSlashSuggestion";

/** Slash menu (`/`) without inserting a document node — only runs commands. */
export function createCollaborateSlashExtension(
  hasDocumentSelection: () => boolean,
) {
  return Extension.create({
    name: "slashCommands",

    addProseMirrorPlugins() {
      return [
        Suggestion({
          editor: this.editor,
          ...createCollaborateSlashSuggestion(hasDocumentSelection),
        }),
      ];
    },
  });
}
